
import { library } from '@fortawesome/fontawesome-svg-core'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { faEdit, faBan, faSave } from '@fortawesome/free-solid-svg-icons'

library.add(faEdit, faBan, faSave )
